// extracted by mini-css-extract-plugin
module.exports = {"left":"left-316o725","right":"right-3TtS-4u","external-id-input":"external-id-input-pF-O1Gr","external-id-edit":"external-id-edit-3tkWm4q","external-id":"external-id-2BEXuf3"};